import React, { useEffect, useState } from 'react'
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons'
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Form, Schema } from 'rsuite';
import Information from '../../../../../Shared/Card/Information';
import {GetReinstatementInformationContent } from '../../../../../Shared/InformationContent/PeInformation';
import AddEditExperienceRecordsModal from './ExperienceRecordModal';
import Experience from '../../../../../Shared/Card/Experience';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import reinstatementService from '../../../../../../services/Public/Reinstatement/PE/peReinstatement.service';
import experienceService from '../../../../../../services/Public/Reinstatement/PE/experience.service';
import Issues from '../../../../../Shared/Card/Issues';
import dayjs from 'dayjs';

function ExperiencePage() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [sectionData, setSectionData] = useState({});

    const [modalShow, setModalShow] = useState(false);
    const [gridData, setGridData] = useState([]);
    const entityId = useSelector(x => x.userInfo.EntityId)
    const appId = useSelector(x => x.currentApplicationId);
    const routes = useSelector(x => x.currentRoutes);
    const [isOverFiveYears, setIsOverFiveYears] = useState(false);
    const sectionId = 7;
    const [modalData, setModalData] = useState({});
    useEffect(() => {
        setHasLoaded(false)
        reinstatementService.peGetSection(appId, sectionId).then((response) => {
            setIsOverFiveYears(response.data.isOverFiveYears);
            setSectionData(response.data);
            updateGridData();
            setHasLoaded(true)
        })
    }, [])
    const { BooleanType } = Schema.Types;
    const model = Schema.Model({
        hasMyNceesExperience: BooleanType().isRequired('This field is required.')
    });
    const openAddEditModal = (values) => {
        if (values.id) {
            setModalData(
                {
                    ...values,
                    verifierEmail: values.emailAddresses[1].contactEmailAddress,
                    verifierPhone: values.phoneNumbers[1].contactPhoneNumber,
                    employerEmail: values.emailAddresses[0].contactEmailAddress,
                    employerPhone: values.phoneNumbers[0].contactPhoneNumber,
                    dateFrom: values.dateFrom ? dayjs(values.dateFrom).format('YYYY-MM') : null,
                    dateTo: values.dateTo ? dayjs(values.dateTo).format('YYYY-MM') : null,
                    modalType: 'Edit'
                });
        }
        else {
            setModalData({
                reinstatementId: appId,
                comments: "",
                dateCrte: null,
                dateFrom: null,
                dateTo: null,
                deleted: false,
                employerName: "",
                employerPosition: "",
                verifierName: "",
                verifierPosition: '',
                verifierEmail: "",
                verifierPhone: "",
                employerEmail: "",
                employerPhone: "",
                employmentType: null,
                entityId: entityId,
                id: 0,
                userCrte: "",
                position: "",
                location: "",
                description: "",
                acceptableDescription: "",
                emailAddresses: [
                    {
                        contactEmailAddress: '',
                        emailAddressParentType: {
                            id: 12,
                            emailAddressParentType: "Reinstatement Experience Employer"
                        },
                        emailAddressType: {
                            id: 1,
                            emailAddressType: ''
                        },
                        id: 0,
                        entityId: entityId,
                        parentId: 0,
                        userCrte: '',
                        dateCrte: null
                    },
                    {
                        contactEmailAddress: '',
                        emailAddressParentType: {
                            id: 13,
                            emailAddressParentType: "Reinstatement Experience Verifier"
                        },
                        emailAddressType: {
                            id: 1,
                            emailAddressType: ''
                        },
                        id: 0,
                        entityId: entityId,
                        parentId: 0,
                        userCrte: '',
                        dateCrte: null
                    }
                ],
                phoneNumbers: [
                    {
                        contactPhoneNumber: '',
                        parentType: {
                            id: 12,
                            phoneParentType: "Reinstatement Experience Employer"
                        },
                        phoneType: {
                            id: 3,
                            phoneType: ''
                        },
                        id: 0,
                        entityId: entityId,
                        parentId: 0,
                        userCrte: '',
                        dateCrte: null
                    },
                    {
                        contactPhoneNumber: '',
                        parentType: {
                            id: 13,
                            phoneParentType: "Reinstatement Experience Verifier"
                        },
                        phoneType: {
                            id: 3,
                            phoneType: ''
                        },
                        id: 0,
                        entityId: entityId,
                        parentId: 0,
                        userCrte: '',
                        dateCrte: null
                    }
                ],
                modalType: "Add"
            })
        }
        setModalShow(true);
    }
    const push = useNavigate();

    const handleSubmit = (validation, event) => {
        if (!sectionData.isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            if (validation) {
                reinstatementService.pePostSectionHasExperience(appId, sectionId, sectionData.hasMyNceesExperience).then((response) => {
                    if (response.data) // If both return something it's good to go
                        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
                });
            }
        }
    }
    const updateGridData = () => {
        experienceService.getExperienceRecords(appId).then((response) => {
            setGridData(response.data)
        });
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div>
            <Container fluid>
                <b>Professional Engineer Reinstatement</b>
                <h4 className="mb-3">Experience</h4>
                <Information content={GetReinstatementInformationContent(isOverFiveYears ? "experience5year" : "experience")} />
                <br />
                {hasLoaded ? <>
                    {modalShow &&
                        <AddEditExperienceRecordsModal updateGrid={updateGridData} modaldata={modalData} show={modalShow} onHide={() => setModalShow(false)} proptitle="Add" />
                    }
                    <Form onSubmit={handleSubmit} model={model} formValue={sectionData} onChange={data => setSectionData(data)}>
                        <Experience appType="reinstatement" type="PE" updateGrid={updateGridData} griddata={gridData} isReadOnly={!sectionData.isUserEditable} openModal={openAddEditModal} hasMyNceesExperience={sectionData.hasMyNceesExperience} />
                        <br />
                        <Issues isUserEditable={true} type={2} sectionId={sectionData.id} /> 
                        <FormActionButtons nextSectionCallback={nextSectionNavigation} isReadOnly={!sectionData.isUserEditable} backToSectionLink="/individual/pereinstatement/sections" />
                    </Form></> : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default ExperiencePage